'use strict'

// import _ from 'lodash'
// import moment from 'moment'

// const CLAIMS = require('./sample/claims.json')

export default {

  timeline: [],

}
